import { Button, ButtonGroup, CircularProgress, TableCell, TableRow, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function UnmappedDocumentRow({ item, onReprocess, processingById }) {
    const { openCategoryFromUnmapped, readOnly } = useBoundContext()
    const processing = Boolean(processingById?.[item.id])

    return (
        <TableRow hover>
            <TableCell>
                <Typography variant="subtitle2">{item.name}</Typography>
            </TableCell>
            <TableCell>
                <Typography variant="caption" color="text.secondary">
                    {item.path}
                </Typography>
            </TableCell>
            <TableCell align="right">
                <ButtonGroup size="small">
                    <Button variant="outlined" onClick={handleOpen} disabled={processing}>
                        Open
                    </Button>
                    <If value={!readOnly}>
                        <Button
                            variant="contained"
                            onClick={handleReprocess}
                            disabled={processing}
                            startIcon={getReprocessIcon()}
                        >
                            <If value={processing}>
                                Reprocessing...
                                <Else>Reprocess</Else>
                            </If>
                        </Button>
                    </If>
                </ButtonGroup>
            </TableCell>
        </TableRow>
    )

    function handleOpen() {
        openCategoryFromUnmapped(item.id)
    }

    function handleReprocess() {
        onReprocess?.(item)
    }

    function getReprocessIcon() {
        if (!processing) return undefined
        return <CircularProgress size={14} color="inherit" />
    }
}
